import React from "react"
import FieldProto from "../proto/field-proto"
import {EntityType} from "../../gd/const/item"
import {RequestForm_FieldTreatAs} from "../../../app/tools/request-forms2/const/const"

export type FieldManagementFormProps = {
    field               : FieldProto
    onSubmit            : callback
    isNewField?         : boolean
    disableRequired?    : boolean
    autoSaveChanges?    : boolean

    // Request form parameters
    showTreatAs?        : boolean
    treatAs?            : RequestForm_FieldTreatAs

    entity?             : EntityType
    // className?  : string;
};

export default function FieldManagementForm(props:FieldManagementFormProps):any {

    return <props.field.renderComponents.managementForm {...props} />

}